import { User } from "../micro-services/user/models/user";


export class Formule {
    id: number;
    name : string;
    price :string;
    recurrence : string;
    coachId : string;
    coach : User; 
    showListBtnBox: false
    nbSeances?: number;
    constructor(){

    }
}
